// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1CAbJ","buttons":"SendReceipts_buttons__3HoOy","email":"SendReceipts_email__2JQKg","bookApptTitle":"SendReceipts_bookApptTitle__2WCan"};